import React, {useEffect, useState, useCallback} from 'react'
import './index.css';
import debounce from 'lodash/debounce';
import CollectionBox from "./components/CollectionBox";
import { Row, Button, Col, Table, Select, Popover, AutoComplete, message, Spin, Tooltip, Modal, List } from "antd";
import { getListRecommendTagWorld, getListParentFilter, getListKnowledge, checkAddKnowledge, addKnowledge, addKnowledgeSame, memberEveryCommoditySave } from '../../../api/inspiration';
import isEmpty from 'lodash/isEmpty';

const tagNameRender = (tagName = []) => {
    // 渲染全部的标签页
    const renderCompletedTagName = (tagName = [], flag) => {
        if (flag) {
            return (
                <ul className={"dingzi-inspiration-ksm-ul"}>
                    {
                        tagName.map((item, index) => {
                            return (
                                <li key={index}>
                                    {item}
                                </li>
                            )
                        })
                    }
                    <li>...</li>
                </ul>
            )
        } else {
            return (
                <ul className={"dingzi-inspiration-ksm-ul"}>
                    {
                        tagName.map((item, index) => {
                            return (
                                <li key={index}>
                                    {item}
                                </li>
                            )
                        })
                    }
                </ul>
            )
        }
    }

    if (tagName.length < 8) {
        return (
            renderCompletedTagName(tagName, false)
        )
    } else {
        const limitTagName = tagName.slice(0, 8);
        return (
            <Popover
                content={renderCompletedTagName(tagName, false)}
            >
                {
                    renderCompletedTagName(limitTagName, true)
                }
            </Popover>
        )
    }

}

const modalTitle = '新增子标签';

const modalTitleSimilar = '新增近义词';

const titleIntroduction = '当前标签词';

const addTagIntroduction = '以当前标签词为父级， 请输入需要新增的标签词';

const addNearSynonym = '请输入当前标签词的近义词';

const parseData = {};

const KnowledgeSystemMaintenance = () => {
    // 标签名
    const [tagName, setTagName] = useState('');
    // 父标签名 Id
    const [parentTagName, setParentTagName] = useState();
    // 下拉框数据
    const [selectList, setSelectList] = useState([]);
    // 下拉框数据是否为空 - 用于判断父级标签是否存在的情况
    const [ifSelectListNull, setIfSelectedListNull] = useState(false);
    // 下拉框是否处于加载
    const [selectLoading, setSelectLoading] = useState(true);
    // 列表数据源
    const [dataSource, setDataSource] = useState([]);
    // 列表的总数量
    const [listTotal, setListTotal] = useState(0);
    // 输入标签词Input框的数据源 - 用以实现推荐
    const [autoCompleteDataSource, setAutoCompleteDataSource] = useState([]);
    // 打开 CollectionBox 模态框
    const [showAddChildrenModal, setShowAddChildrenModal] = useState(false);
    // 模态框标题
    const [modalContentTitle, setModalContentTitle] = useState('');
    // 模态框中内容是否加载完毕
    const [modalLoading, setModalLoading] = useState(false);
    // 模态框中，新增的子标签输入框的值
    const [addTagInputValue, setAddTagInputValue] = useState('');
    // 新增的子标签
    const [childrenTag, setChildrenTag] = useState([]);
    // 打开的模态框是新增子级标签模态框还是新增近义词的模态框 false-新增子级标签，true-新增近义词
    const [tagOrSynonym, setTagOrSynonym] = useState(false);
    // 传递给组件的每行数据的id
    const [id, setId] = useState(0);
    // 确认模态框
    const [confirmModal, setConfirmModal] = useState(false);
    // 确认模态框中的展示数据
    const [confirmModalData, setConfirmModalData] = useState([]);
    // 一页的数据量
    const [pageSize, setPageSize] = useState(10);
    // 节流方法
    const de = async value => {
        const data = await getListRecommendTagWorld(value);
        onAutoCompleteSelect(value);
        if (data?.data) {
            await setAutoCompleteDataSource(data.data);
            if (data.data.length === 0) {
                message.info('没有该标签的数据哦');
                setIfSelectedListNull(true);
            }
        }
    }

    // 利用 useCallback 暂存节流
    const delay = useCallback(debounce(q => de(q) , 500), []);

    // antd table 列表选项
    const columns = [
        {
            title: '标签词Id',
            dataIndex: 'id',
            width: '15%',
            sorter: true,
        }, {
            title: '标签词',
            dataIndex: 'name',
            width: '15%',
        }, {
            title: '标签近义词',
            dataIndex: 'sameWords',
            width: '20%',
            ellipsis: 'true',
            render: (item) => {
                if (item instanceof Array) {
                    return (
                        tagNameRender(item)
                    )
                } else {
                    return (
                        <span>
                            {item}
                        </span>
                    )
                }
            }
        }, {
            title: '最后修改时间',
            dataIndex: 'updateTime',
            width: '20%',
            sorter: true,
        }, {
            title: '修改人ID',
            dataIndex: 'modifyUser',
            width: '10%',
        }, {
            title: '操作',
            width: '20%',
            render: (text, record) => {
                return <>
                    <Button type={"link"} onClick={() => {addNewChildrenTag(record, false)}}>新增子级标签</Button>
                    <span className={"dingzi-inspiration-ksm-gap"} />
                    <Button type={"link"} onClick={() => {addNewChildrenTag(record, true)}}>新增近义词</Button>
                </>
            }
        }
    ]

    // 输入标签词
    const tagNameChange = (e) => {
        setSelectList([]);
        setAutoCompleteDataSource([]);
        setParentTagName();
        if (!isEmpty(e.replace(/\s*/g,""))) {
            setTagName(e);
            delay(e);
        }
    }

    // 选中下方的标签
    const onAutoCompleteSelect = async (e) => {
        await setSelectLoading(true);
        const data = await getListParentFilter(e);
        if (data?.error?.code === 0) {
            await setSelectList(data.data);
            if (data.data.length === 0) {
                await setIfSelectedListNull(true);
            } else {
                await setIfSelectedListNull(false);
            }
            await setSelectLoading(false);
        } else {
            await setSelectLoading(false);
        }
    }

    // 筛选父级下拉框变化的处理函数
    const selectChange = (e) => {
        setParentTagName(e);
    }

    // 点击查询按钮的事件处理函数
    const queryKnowledge = async () => {

        parseData.page = 1;
        parseData.pageSize = 10;
        if (isEmpty(tagName.replace(/\s*/g, ""))) {
            message.info('请输入标签词！');
            return;
        }
        // 利用 ifSelectListNull 来判断父级是否为空，如果父级为不为空，则要求用户选择父级
        if (parentTagName == null && !ifSelectListNull) {
            message.info('父级有标签，请选择父级');
            return;
        }
        parseData.parentId = parentTagName;
        parseData.tagWord = tagName;
        const dataSource =  await getListKnowledge(parseData);
        if (dataSource?.error?.code === 0) {
            setDataSource(dataSource.data.knowledgeList);
            setPageSize(dataSource.data.knowledgeList.length);
            setListTotal(Number(dataSource.data.total));
        } else {
            message.info('发生错误，联系管理员');
        }
    }
    // 表单变化的处理函数
    const tableChange = async (pagination, filters, sorter) => {
        const { pageSize, current } = pagination;
        const { columnKey, order } = sorter;
        if (isEmpty(tagName) || isEmpty(tagName.replace(/\s*/g, ""))) {
            return message.error('标签词或者父级为空！');
        }
        if (current === 1) {
            parseData.pageSize = 10;
            parseData.page = current;
        } else {
            parseData.pageSize = pageSize;
            parseData.page = current;
        }
        if (columnKey) {
            if (columnKey === 'updateTime') {
                parseData.column = 'update_time';
            } else {
                parseData.column = columnKey;
            }
        }
        if (order === 'ascend') {
            parseData.desc = false;
        } else if (order === 'descend') {
            parseData.desc = true;
        } else {
            parseData.desc = false;
        }
        const data = await getListKnowledge(parseData);
        if (data?.error?.code === 0) {
            setDataSource(data.data.knowledgeList);
        } else {
            message.info('发生错误，联系管理员');
        }
    }

    // 新增子标签按钮的事件处理
    const addNewChildrenTag = (record, flag) => {
        setTagOrSynonym(flag);
        setShowAddChildrenModal(true);
        setModalContentTitle(record.name);
        setId(record.id);
    }

    // 以下为子组件所使用的事件处理函数

    // 子组件内部 Input 框输入时的处理函数
    const addTagInputValueChangeHandler = (e) => {
        const value = e.target.value;
        setAddTagInputValue(value);
    }

    // 模态框关闭
    const onCancel = () => {
        setShowAddChildrenModal(false);
        setChildrenTag([]);
        setAddTagInputValue('');
    }

    // 模态提交
    const onOk = async () => {
        let snsArr = addTagInputValue.split(/[(\r\n)\r\n]+/);
        snsArr.forEach((item,index)=>{
            if(!item){
                snsArr.splice(index,1);//删除空项
            }
        })
        setChildrenTag(snsArr);
        if (addTagInputValue.indexOf(',') > -1 && addTagInputValue.indexOf('，') > -1) {
            message.info('不合输入规则！');
            return;
        }
        if (snsArr.length === 1 && snsArr[0] === '') {
            message.info('没有添加任何近义词！');
            return;
        }
        if (tagOrSynonym) {
            if (snsArr.length === 0) {
                message.info('没有添加任何近义词！');
                return;
            }
            const parseData = {
                knowledgeId: id,
                words: snsArr,
            }
            // const result = await addKnowledgeSame(parseData);
            // if (result?.error?.code === 0) {
            //     message.success('提交成功');
            //     queryKnowledge();
            //     onCancel();
            // } else {
            //     message.error('提交失败，请查看输入是否符合规则，如果符合报错，则请联系管理员');
            //     onCancel();
            // }
        } else {
            if (snsArr.length === 0) {
                message.info('没有添加任何子标签！');
                return;
            }
            // const result = await checkAddKnowledge(snsArr);
            // if (result?.error?.code === 0) {
            //     if (result.data.length === 0) {
            //         setModalLoading(false);
            //         const parseData = {
            //             knowledgeId: id,
            //             words: snsArr,
            //         }
            //         const result = await addKnowledge(parseData);
            //         if (result?.error?.code === 0) {
            //             message.success('添加成功');
            //             queryKnowledge();
            //             onConfirmModalCancelClick();
            //             onCancel();
            //         }
            //     } else {
            //         setConfirmModal(true);
            //         setModalLoading(true);
            //         setModalLoading(false);
            //         setConfirmModalData(result.data);
            //     }
            // } else {
            //     setModalLoading(false);
            //     message.error('提交失败，请查看输入是否符合规则，如果不符合，则请联系管理员');
            // }
        }
    }

    // 以下为确认模态框中的内容

    // 确认模态框提交
    const onConfirmModalOkClick = async () => {
        const parseData = {
            knowledgeId: id,
            words: childrenTag,
        }
        const result = await addKnowledge(parseData);
        if (result?.error?.code === 0) {
            message.success('添加成功');
            queryKnowledge();
            onConfirmModalCancelClick();
            onCancel();
        }
    }

    // 确认模态框取消
    const onConfirmModalCancelClick = async () => {
        setConfirmModal(false);
    }

    return (
        <div 
            className={"dingzi-inspiration-ksm"}
        >
            <Row
                style={{
                    marginBottom: 50,
                }}
            >
                <h1
                    style={{
                        fontSize: 40,
                        margin: 0,
                    }}
                >知识体系管理</h1>    
            </Row>
            <Row>
                <Col span={9}>
                    <AutoComplete
                        placeholder={"输入标签词（必填）"}
                        style={{
                            width: 400,
                        }}
                        onChange={tagNameChange}
                        size={"large"}
                        dataSource={autoCompleteDataSource}
                        onSelect={onAutoCompleteSelect}
                    />
                </Col>
                <Col span={9}>
                    {
                        !ifSelectListNull ? (
                            <Select
                                placeholder={"筛选所选父级（必填）"}
                                style={{ width: 300 }}
                                size={"large"}
                                onChange={selectChange}
                                loading={selectLoading}
                                value={parentTagName}
                                >
                                {
                                    selectList.map((item, index) => {
                                        return (
                                            <Select.Option key={item.id} value={item.id}>
                                                { item.name }
                                            </Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        ): (
                            <Tooltip
                                title={"暂无父级标签，请直接搜索"}
                            >
                                <Select
                                    placeholder={"筛选所选父级（必填）"}
                                    style={{ width: 300 }}
                                    size={"large"}
                                    onChange={selectChange}
                                    value={parentTagName}
                                >
                                    {
                                        selectList.map((item, index) => {
                                            return (
                                                <Select.Option key={item.id} value={item.id}>
                                                    { item.name }
                                                </Select.Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        )
                    }
                </Col>
                <Col span={6}>
                    <Button
                        type={"primary"}
                        size={"large"}
                        onClick={queryKnowledge}
                    >查询</Button>
                </Col>
            </Row>
            <Row style={{
                marginTop: 20,
                height: '100%',
            }}>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    onChange={tableChange}
                    rowKey={(e) => e.id}
                    pagination={{
                        pageSize: pageSize,
                        total: listTotal,
                        showQuickJumper: true,
                    }}
                />
            </Row>
            <CollectionBox
                title={modalContentTitle}
                titleIntroduction={titleIntroduction}
                contentIntroduction={tagOrSynonym?addNearSynonym:addTagIntroduction}
                visible={showAddChildrenModal}
                modalTitle={tagOrSynonym?modalTitleSimilar:modalTitle}
                onCancel={onCancel}
                onOk={onOk}
                addTagInputValue={addTagInputValue}
                addTagInputValueChangeHandler={addTagInputValueChangeHandler}
                tagOrSynonym={tagOrSynonym}
            >
            </CollectionBox>
            <Modal
                visible={confirmModal}
                onCancel={onConfirmModalCancelClick}
                title={'重复筛选'}
                destroyOnClose
                footer={
                    <>
                        <Button type={'primary'} onClick={onConfirmModalOkClick} style={{marginRight: 30}}>确认添加</Button>
                        <Button type={"primary"} onClick={onConfirmModalCancelClick}>返回查看</Button>
                    </>
                }
            >
                <Spin
                    spinning={modalLoading}
                >
                    <List
                        dataSource={confirmModalData}
                        renderItem={
                            item => (
                                <p>{item}</p>
                            )
                        }
                        locale={{
                            emptyText: '没有重复'
                        }}
                    />
                </Spin>  
            </Modal>
        </div>
    )
}

export default KnowledgeSystemMaintenance;